module.exports = __webpack_public_path__ + "static/media/sga0005.42918b7c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/ressources/sgal/sga0005.jpg
// module id = 277
// module chunks = 0